export default () => ({
  nexmo: {
    text: '',
    selected: false
  },
  settings: {
    heading: '',
    content: '',
    link: '',
    button_items: [
      {
        button_text: '',
        tags: []
      }
    ],
    package: null,
    link_notification: false,
    package_notification: false,
    response_notification: false
  },
  onesignal: {
    selected: false
  },
  email: {
    heading: '',
    subject_same: false,
    content: '',
    content_same: false,
    selected: false
  }
})
